<template>
  <div class='technology-validation-triggered-table-cell'>
    <span class="amount">{{ assetsAmount }}</span>
  </div>
</template>

<script>
export default {
  name: 'TechnologyValidationTriggeredTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      assetsListPopup: false,
    };
  },
  computed: {
    assetsAmount() {
      return this.item[this.column.field] ? this.item[this.column.field] : 0;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.technology-validation-triggered-table-cell {
  width: 100%;
  display: flex;
  justify-content: center;

  .amount {
    z-index: 3;
    color: var(--text-primary);
    font-family: $font-family-semibold;
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(17);
    font-weight: 600;
  }
}
</style>
